// extracted by mini-css-extract-plugin
export default {"PremierCountry":"PremierCountry_PremierCountry","PremierImage":"PremierCountry_PremierImage","PremierCountryName":"PremierCountry_PremierCountryName"};